<template>
  <div
    :title="$t('previewAvailableSoon')"
    class="poster-wrapper"
    :class="{small: small, medium: medium, full: full}"
    style="opacity: 0.6"
  >
    <!-- Radio Placeholder -->
    <v-layout
      v-if="ctype === 'radio' || ctype === 'closingtime'"
      row
      justify-center
      nowrap
    >
      <v-icon
        v-if="closingtime"
        :style="{
          'font-size': previewIconSize + 'em',
          width: previewWidth + 'px',
          height: previewHeight + 'px',
        }"
      >
        campaign
      </v-icon>
      <span v-else>
        <v-img
          src="/static/radiospot_play_button.svg"
          :width="previewWidth"
          cover
        />
      </span>
    </v-layout>
    <!-- TV Placeholder -->
    <v-layout
      v-if="ctype === 'tv'"
      justify-center
      align-center
    >
      <v-subheader
        v-if="showTvAsText"
        class="text-xs-center"
        :class="{
          caption: $vuetify.breakpoint.xs,
          subheading: $vuetify.breakpoint.smAndUp,
        }"
        style="user-select: none"
      >
        {{ $t('previewAvailableSoon') }}
      </v-subheader>
      <v-icon
        v-else
        :style="{
          'font-size': previewIconSize - 0.75 + 'em',
          width: previewWidth + 'px',
          height: previewHeight + 'px',
        }"
      >
        tv
      </v-icon>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    ctype: {
      type: String,
      required: true,
    },
    /**
     * Why is this an extra flag when there is A SpotEntry ctype of
     * 'closingtime' already? Because this widget is not just used for
     * SpotEntries, but also in contexts where that ctype does not occur,
     * but where we still may have to display a closingtime RadioSpot.
     */
    closingtime: {
      type: Boolean,
      default: false,
    },
    showTvAsText: {
      type: Boolean,
      default: false,
    },
    /** Default preview is tiny. We can increase it to small or medium. */
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    previewWidth() {
      const defaultWidth = 96;
      if (this.small) {
        return defaultWidth * 2;
      }
      if (this.medium) {
        return defaultWidth * 3;
      }
      if (this.full) {
        return defaultWidth * 3.5;
      }
      return defaultWidth;
    },
    previewHeight() {
      return this.previewWidth / (16 / 9);
    },
    previewIconSize() {
      const defaultSize = 4;
      if (this.small) {
        return defaultSize * 2;
      }
      if (this.medium) {
        return defaultSize * 3;
      }
      if (this.full) {
        return defaultSize * 3.5;
      }
      return defaultSize;
    },
  },
};
</script>

<style scoped>
.poster-wrapper {
  width: 96px;
  height: 54px;
  display: flex;
  justify-items: center;
}
.poster-wrapper.small {
  width: calc(96px * 2);
  height: calc(54px * 2);
}
.poster-wrapper.medium {
  width: calc(96px * 3);
  height: calc(54px * 3);
}
.poster-wrapper.full {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewUnprocessed.vue